
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/effectiveness",
      function () {
        return require("private-next-pages/effectiveness.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/effectiveness"])
      });
    }
  